import IconActions from '../../../../shared/components/IconActions';
import React from 'react';
import { Clock, Eye, PauseCircle, Pencil, PlayCircle } from '../../../../shared/assets/AppIcons';
import { Badge } from '@/shared/ui/badge';
import { Button } from '@/shared/ui/button';
import { Card, CardContent } from '@/shared/ui/card';
import { getAutomationTotalSavedTime } from '@/modules/automations/utils';

export default function ActiveAutomationCard({
  automation,
  renewalActive,
  expirationDate,
  formatDateTime,
  onOpenDetails,
  onOpenEdit,
  onOpenPause,
  onToggleRenewal,
}) {
  const IconComponent = automation.icona;
  const savedTime = getAutomationTotalSavedTime(automation);

  return (
    <Card className="border-[var(--border)] hover:border-[var(--success-border)] transition-colors">
      <CardContent className="p-6">
        <div className="flex items-start justify-between">
          <div className="flex gap-4">
            <div className="w-14 h-14 rounded-xl flex items-center justify-center bg-[var(--success-soft)]">
              <IconComponent className="text-[var(--success-text)]" size={32} />
            </div>
            <div>
              <div className="flex items-center gap-2 mb-1 flex-wrap">
                <h3 className="font-bold text-lg text-[var(--text-primary)]">{automation.nome}</h3>
                <Badge className="bg-[var(--success-soft)] text-[var(--success-text)]">Attivo</Badge>
                {!renewalActive ? (
                  <Badge className="bg-[var(--warning-soft)] text-[var(--warning-text)]">
                    <Clock size={16} className="mr-1" />
                    Scade il {expirationDate}
                  </Badge>
                ) : null}
                <Badge variant="outline" className="border-[var(--border)]">
                  {automation.categoria}
                </Badge>
              </div>
              <p className="text-sm text-[var(--text-secondary)] mb-4">{automation.descrizione}</p>

              <div className="grid grid-cols-4 gap-6">
                <div>
                  <p className="text-xs text-[var(--text-secondary)]">Ultimo Utilizzo</p>
                  <p className="text-sm font-semibold text-[var(--text-primary)]">
                    {formatDateTime(automation.ultimoUtilizzo)}
                  </p>
                </div>
                <div>
                  <p className="text-xs text-[var(--text-secondary)]">Utilizzi Totali</p>
                  <p className="text-sm font-semibold text-[var(--text-primary)]">{automation.utilizziTotali} volte</p>
                </div>
                <div>
                  <p className="text-xs text-[var(--text-secondary)]">Utilizzi Questo Mese</p>
                  <p className="text-sm font-semibold text-[var(--text-primary)]">{automation.utilizziMese} volte</p>
                </div>
                <div>
                  <p className="text-xs text-[var(--text-secondary)]">Tempo Medio Risparmiato</p>
                  <p className="text-sm font-semibold text-[var(--success-text)]">
                    ~{automation.tempoMedioRisparmiato} min/utilizzo
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="text-right">
            <div className="mb-4">
              <p className="text-xs text-[var(--text-secondary)]">Costo Mensile</p>
              <p className="text-2xl font-bold text-[var(--text-primary)]">EUR {automation.costoMensile.toFixed(2)}</p>
              <p className={`text-xs mt-1 ${renewalActive ? 'text-[var(--success-text)]' : 'text-[var(--warning-text)]'}`}>
                {renewalActive ? 'Rinnovo automatico attivo' : 'Rinnovo disattivato'}
              </p>
            </div>
            <div className="flex gap-2"><IconActions>
              <Button variant="outline" size="sm" onClick={() => onOpenDetails(automation)}>
                <Eye size={16} className="mr-1" />
                Dettagli
              </Button>
              <Button variant="outline" size="sm" onClick={() => onOpenEdit(automation)}>
                <Pencil size={16} className="mr-1" />
                Modifica
              </Button>
              {renewalActive ? (
                <Button
                  variant="outline"
                  size="sm"
                  className="text-[var(--warning-text)] border-[var(--warning-border)] hover:bg-[var(--warning-soft)]"
                  onClick={() => onOpenPause(automation)}
                >
                  <PauseCircle size={16} className="mr-1" />
                  Pausa
                </Button>
              ) : (
                <Button
                  variant="outline"
                  size="sm"
                  className="text-[var(--success-text)] border-[var(--success-border)] hover:bg-[var(--success-soft)]"
                  onClick={() => onToggleRenewal(automation.id)}
                >
                  <PlayCircle size={16} className="mr-1" />
                  Riprendi
                </Button>
              )}
            </IconActions></div>
          </div>
        </div>

        <div className="mt-6 pt-4 border-t border-[var(--border)]">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-[var(--success-soft)] rounded-lg flex items-center justify-center">
              <Clock className="text-[var(--success-text)]" size={16} />
            </div>
            <div>
              <p className="text-xs text-[var(--text-secondary)]">Tempo totale risparmiato</p>
              <p className="text-lg font-bold text-[var(--success-text)]">
                {savedTime.hours} ore e {savedTime.minutes} minuti
              </p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
